import React from 'react'
import PropTypes from 'prop-types'
import '../../styles/components/ButtonStart.scss'

const ButtonStart = ({ children, onClick }) => (
  <button type="button" className="ButtonStart" onClick={onClick}>
    {children}
  </button>
)

ButtonStart.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
}

export default ButtonStart
